<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay :retain-focus="false" persistent
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <!-- Primer v-if -->
      <v-btn v-if="!addUsersAdminCompany" v-bind="attrs" v-on="on" x-medium large block rounded color="primary" dark>
        Agregar Usuario
      </v-btn>
      <!-- Segundo v-if con la lógica adicional -->
      <div v-if="addUsersAdminCompany">
        <!-- Si userAdminId tiene datos, deshabilitar el botón y ponerlo en gris -->
        <div v-if="userAdminId.userId != null" class="user-btn">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn disabled color="grey" class="ma-2" style="width: 66px; height: 66px; border-radius: 50%;"
                v-bind="attrs" v-on="on">
                <v-icon dark>mdi-account-multiple-plus</v-icon>
              </v-btn>
            </template>
            <span slot="activator">Agregar Usuario</span>
            <span>Texto del tooltip</span>
          </v-tooltip>
        </div>
        <!-- Si userAdminId es null, mostrar el botón normal -->
        <div v-else class="user-btn">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab dark large color="primary" v-bind="attrs" v-on="on" @click="dialog = true">
                <v-icon dark>mdi-account-multiple-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar Usuario</span>
          </v-tooltip>
        </div>
      </div>
    </template>

    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark class="btn btn-primary" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Agregar Usuario</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-tabs-items v-model="tab" class="container mt-5">

        <v-tab-item>
          <div class="container mt-4">
            <addUserAdminid :addUsersAdminCompanyId="addUsersAdminCompany" />
          </div>
        </v-tab-item>
      </v-tabs-items>

    </v-card>
  </v-dialog>

</template>

<script>

import addUserAdminid from '@/views/users_admin/pages/add_users_admin/components/form_users_admin_component.vue';
import EventBus from '@/utils/event_bus.js';

import { mapGetters } from "vuex";

import {
  USERSADMIN_M,
  GET_USER_ADMIN_COMPANY_ID
} from "@/views/users_admin/store/types/types.js";

export default {

  name: "addUserAdmin",
  props: {
    addUsersAdminCompany: {
      require: false
    },
  },
  components: {
    addUserAdminid,
  },

  data() {
    return {
      dialog: false,
      tab: null,

      items: [
        "Datos Completos"
      ],

    }

  },

  async mounted() {

    this.localAddUsersAdminCompany = this.addUsersAdminCompany || ""; // Asignar una cadena vacía si es nula
    EventBus.$on('formUserAdmin-submitted-successfully', () => {
      this.closeDialog();
      EventBus.$emit('reload-UserAdmin');
    });

  },

  methods: {
    closeDialog() {

      this.$store.commit('RESET_STATE');
      this.dialog = false;
      window.location.reload();

    },
  },

  computed: {

    ...mapGetters({
      userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_COMPANY_ID}`],
    }),

  }
};

</script>
